import { lazy } from 'solid-js'
import { messages } from '../../pages/points-page/points-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/points-page/points-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/points',
    titleMessage: messages.titleMessage,
}
